import React, { FC, PropsWithChildren } from 'react';
import useLocalStorage from 'react-localstorage-hook';

import { CHAIN_ID } from '@constants/common/chain.constants';
import {
  CURRENT_CHAIN_ID,
  HIDE_CREATED_VAULT_MODAL,
  SLIPPAGE_TOLERANCE,
  VAULTS_FILTERS,
  VAULTS_VIEW,
  VIEW_ADDRESS,
} from '@constants/common/localStorage.constants';
import { DEFAULT_SLIPPAGE_PARAM } from '@constants/common/slippage.constants';
import { ViewModes } from '@constants/vaults/common.constants';

const LocalStorage: FC<PropsWithChildren> = ({ children }) => {
  useLocalStorage(SLIPPAGE_TOLERANCE, DEFAULT_SLIPPAGE_PARAM);
  useLocalStorage(CURRENT_CHAIN_ID, CHAIN_ID.ARBITRUM);
  useLocalStorage(VAULTS_VIEW, ViewModes.List);
  useLocalStorage(HIDE_CREATED_VAULT_MODAL, false);
  useLocalStorage(VIEW_ADDRESS, null);
  useLocalStorage(VAULTS_FILTERS, '');

  return <>{children}</>;
};

export default LocalStorage;
